const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/raw-footage/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { createFileRoute } from '@tanstack/react-router';
/**
 * Raw-footage landing: prompt to pick a project from the secondary tree.
 */
export const Route = createFileRoute('/_authenticated/_app/raw-footage/')({
  beforeLoad: requireCapabilities(has => has('assets.list')),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});